import {useState, useCallback, createContext, useEffect, useContext} from "react";


export const HelpContext = createContext();

export const useProvideHelp = () => {

  const [state, setState] = useState({started: false,visible: false,steps: []});

  const startTour = useCallback(() => setState(prevState => ({...prevState,started: true,visible: true})),[]);

  const stopTour = useCallback(() => setState(prevState => ({...prevState,started: false,visible: false})),[]);

  const showTour = useCallback(() => setState(prevState => ({...prevState, visible: true})),[]);

  const hideTour = useCallback(() => setState(prevState => ({...prevState, visible: false})),[]);

  const setSteps = useCallback((steps) => setState(prevState => ({...prevState, steps})),[]);

  return {
    tourStarted: state.started,
    tourVisible: state.visible,
    steps: state.steps,
    startTour,
    stopTour,
    showTour,
    hideTour,
    setSteps,
  };
}

export const useHelp = () => {
  return useContext(HelpContext);
}

export const useHelpTour = ({helpSteps, setStepsWhen = true, isLoading}) => {
  const {tourStarted, setSteps, showTour} = useHelp();

  useEffect(() => {
      if (setStepsWhen) {
        setSteps(helpSteps);
      }
    },[helpSteps, setSteps, setStepsWhen]
  );

  useEffect(() => {
      if (tourStarted && !isLoading) {
        showTour();
      }
    },[tourStarted, isLoading, showTour]
  )
}

export const HelpProvider = ({ children }) => {
  const help = useProvideHelp();

  return (
    <HelpContext.Provider value={help}>
      {children}
    </HelpContext.Provider>
  );
}
